import React, { useState } from "react";
import DocxImportBaseModal from "./docx-import-base-modal";
import SectionDiffPreview from "./section-diff-preview";
import { Checkbox, Button } from "antd";
import "../styles/docx-import-modal.scoped.scss";

const statusLabel = {
    new: "New",
    modified: "Modified",
    unchanged: "Unchanged",
};

const DocxImportDiffModal = ({
    visible,
    onCancel,
    onSave,
    previewData = { sections: [], comments: [] },
    docName,
    setDocName,
    acceptedSections,
    setAcceptedSections,
}) => {
    const [diffIdx, setDiffIdx] = useState(null);

    const handleSectionToggle = (idx) => {
        const section = previewData.sections[idx];
        const prev = acceptedSections[idx] || { status: section.status, accepted: false };
        setAcceptedSections(idx, section.status, !prev.accepted);
    };

    const allSectionsAccepted = Object.values(acceptedSections).some(
        (section) => section.status !== "unchanged" && section.accepted,
    );

    const canSave = docName && allSectionsAccepted;

    const renderSection = (section, idx) => {
        const isDisabled = !(acceptedSections[idx] && acceptedSections[idx].accepted);
        return (
            <div className={`section-list-item ${isDisabled ? "disabled" : ""}`}>
                <div className="section-header">
                    <div className="section-header-left">
                        <Checkbox
                            checked={!!(acceptedSections[idx] && acceptedSections[idx].accepted)}
                            onChange={() => handleSectionToggle(idx)}
                            className="checkbox"
                        />
                        <b>{section.title}</b>
                    </div>
                    <div className="section-header-right">
                        <span className={`status status--${section.status}`}>
                            {statusLabel[section.status]}
                        </span>
                        {(section.status === "modified" || section.status === "new") && (
                            <Button
                                size="small"
                                onClick={() => setDiffIdx(diffIdx === idx ? null : idx)}
                                className="diff-btn"
                            >
                                {diffIdx === idx ? "Hide Preview" : "Preview"}
                            </Button>
                        )}
                    </div>
                </div>
                {diffIdx === idx && (
                    <SectionDiffPreview
                        oldSection={section.status === "modified" ? section.oldSection : null}
                        newSection={section}
                    />
                )}
            </div>
        );
    };

    return (
        <DocxImportBaseModal
            visible={visible}
            onCancel={onCancel}
            onSave={onSave}
            docName={docName}
            setDocName={setDocName}
            acceptedSections={acceptedSections}
            setAcceptedSections={setAcceptedSections}
            previewData={previewData}
            canSave={canSave}
            renderSection={renderSection}
            isDiff={true}
        />
    );
};

export default DocxImportDiffModal;
